import {
  CellListContainer,
  CellListContent,
  CellListIcon,
  CellListText,
} from './CellListCSS';

export const CellList = ({
  value,
  color,
  icon,
  onClick,
  onMouseUp,
  unit = '',
  label,
  isStacked,
}) => {
  return (
    <CellListContainer
      onClick={onClick}
      onMouseUp={onMouseUp}
      $label={label}
      $isStacked={isStacked}
    >
      {' '}
      <CellListContent $isStacked={isStacked}>
        <CellListIcon $color={color} $icon={icon} />
        <CellListText>
          {value}
          {unit}
        </CellListText>
      </CellListContent>
    </CellListContainer>
  );
};
